import {
  Button,
  Space,
  Tabs,
  Typography,
  BackTop,
  Tooltip,
} from '@douyinfe/semi-ui';
import React, { useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { IconArrowUp } from '@douyinfe/semi-icons';
import styled from '@jupiter/plugin-runtime/styled';
import { useScroll } from '@byted/hooks';
import { useHistory } from '@jupiter/plugin-runtime/router';
import { Banners } from './Banners';
import { UserHome } from './UserHome';
import { PostList } from './PostList';
import { NoticeCard, Topic, AddBoard } from './NoticeCard';
import styles from './index.module.scss';
import { useGetPostsByGroup } from './NoticeCard/hooks';
import { IconPost } from './IconPost';
import { IconProtocol } from './IconProtocol';
import { useScope } from '@/hooks/useScope';

const clx = classnames.bind(styles);

export const IndexPage = () => {
  const [shouldFixed, setShouldFixed] = useState(false);
  const scrollListenRef = useRef<HTMLDivElement | null>(null);
  const scrollListenAnothorRef = useRef<HTMLDivElement | null>(null);
  const [scrollParentRef] = useScroll<HTMLDivElement>(
    undefined,
    {
      onScroll() {
        if (Number(getTopDistance()) < 140 && !shouldFixed) {
          setShouldFixed(true);
        }
        if (distanceDiff() < 14 && shouldFixed) {
          setShouldFixed(false);
        }
      },
    },
    [shouldFixed],
  );

  const [choice, setChoice] = useState<'recommend' | 'hottest'>('recommend');
  const history = useHistory();
  const scope = useScope();
  const { getPostsByGroup, posts, loading } = useGetPostsByGroup();

  const getTopDistance = () => {
    if (scrollListenRef.current) {
      return scrollListenRef.current.getBoundingClientRect().top;
    }
    return undefined;
  };

  const distanceDiff = () => {
    const topDistance =
      scrollListenAnothorRef.current?.getBoundingClientRect().bottom;

    if (topDistance && topDistance < 0) {
      return (
        Math.abs(topDistance) +
        Number(scrollListenRef.current?.getBoundingClientRect().top)
      );
    } else {
      return (
        Number(scrollListenRef.current?.getBoundingClientRect().top) -
        Number(topDistance)
      );
    }
  };

  return (
    <div
      ref={scrollParentRef}
      className={clx(
        'flex justify-center w-full pt-8 h-screen mx-auto overflow-auto ',
        'container',
      )}
      style={{
        maxWidth: '1220px',
        minWidth: '808px',
      }}>
      <div
        style={{
          width: '808px',
        }}>
        <Banners />
        <div className="bg-white px-8 pt-6 mt-4 rounded-xl ">
          <div className="flex justify-between">
            <Typography.Title heading={4}>交流专区</Typography.Title>
            <Button
              className="w-[72px] mb-3 h-8"
              type={'primary'}
              theme={'solid'}
              onClick={() => {
                history.push(`/${scope}/post/new`);
              }}>
              发帖
            </Button>
          </div>
          <Tabs
            defaultActiveKey="all"
            keepDOM={false}
            lazyRender={true}
            className={styles.postTab}
            tabBarExtraContent={
              <Space>
                <StyledChoiceButton
                  selected={choice === 'recommend'}
                  onClick={() => setChoice('recommend')}>
                  推荐
                </StyledChoiceButton>
                <StyledChoiceButton
                  selected={choice === 'hottest'}
                  onClick={() => setChoice('hottest')}>
                  最热
                </StyledChoiceButton>
              </Space>
            }>
            <Tabs.TabPane tab={'全部'} itemKey={'all'}>
              <PostList
                scrollParentRef={scrollParentRef}
                postType={'all'}
                choice={choice}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={'文章'} itemKey={'share'}>
              <PostList
                scrollParentRef={scrollParentRef}
                postType={'share'}
                choice={choice}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={'问答'} itemKey={'question'}>
              <PostList
                scrollParentRef={scrollParentRef}
                choice={choice}
                postType={'question'}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
      <div className="w-[396px] ml-4 break-all">
        <UserHome />
        <div className={'mt-4'} ref={scrollListenAnothorRef}>
          <NoticeCard
            data={posts}
            loading={loading}
            refetch={() => getPostsByGroup()}
          />
          <AddBoard refetch={() => getPostsByGroup()} />
        </div>
        <div
          ref={scrollListenRef}
          className={shouldFixed ? 'fixed top-[140px] w-full' : 'w-full'}>
          <Topic />
        </div>
      </div>
      {scrollParentRef.current && (
        <Tooltip content={'返回顶部'} position={'left'}>
          <StyledBackTop target={() => scrollParentRef.current}>
            <IconArrowUp />
          </StyledBackTop>
        </Tooltip>
      )}
      <IconPost />
      <IconProtocol />
    </div>
  );
};

const StyledBackTop = styled(BackTop)`
  display: flex;
  align-items: center;
  background-color: #fff;
  height: 48px;
  width: 48px;
  right: 32px;
  border-radius: 100%;
  justify-content: center;
  color: rgba(23, 26, 28, 0.65);
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.1));
  &:hover {
    color: #3c89ff;
  }
`;

type StyledChoiceButtonProps = {
  selected: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const ChoiceButton: React.FC<StyledChoiceButtonProps> = ({
  children,
  selected,
  ...reset
}) => <div {...reset}>{children}</div>;

const StyledChoiceButton = styled(ChoiceButton)`
  font-size: 14px;
  line-height: 20px;
  padding: 2px 12px;
  font-weight: 400;
  border-radius: 3px;
  color: rgba(23, 26, 28, 0.45);
  cursor: pointer;
  ${({ selected = false }) => {
    if (selected) {
      return `
    color:#171A1C ;
    border-radius: 3px;
    background-color: rgba(46, 50, 56, 0.05);
    cursor:default ;
    font-weight: 500;
    cursor: pointer;

    `;
    }
    return ``;
  }}
`;
